import { render, staticRenderFns } from "./Issuer.vue?vue&type=template&id=58137e42"
import script from "./Issuer.vue?vue&type=script&lang=js"
export * from "./Issuer.vue?vue&type=script&lang=js"
import style0 from "./Issuer.vue?vue&type=style&index=0&id=58137e42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports